// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5609229f","455":"e0004b9f","878":"2d72144c","977":"0b9402d9"}[chunkId] + ".chunk.js";
};